import {UPDATE_SHOP, UPDATE_SHOP_BALANCE} from "Redux/actions/shop";
import {SHOP_COIN_ABBREVIATION} from "Setup/config";

let initialState = {
    shop: null,
    items: null,
    isLoaded: false,
    balance: 0,
    // Distinguishes "no coins" from "we haven't been told yet" — the purchase
    // buttons must not disable themselves on an assumed zero.
    isBalanceLoaded: false,
    abbreviation: SHOP_COIN_ABBREVIATION,
    isFakeShop: false
};

const shopReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SHOP:
            return {...state, isLoaded: true, shop: action.newShop, items: action.newItems, isFakeShop: action.isFakeShop};
        case UPDATE_SHOP_BALANCE:
            return {
                ...state,
                balance: action.balance,
                isBalanceLoaded: true,
                // Keep whatever label we already have when a response omits it,
                // rather than blanking the unit next to every price.
                abbreviation: action.abbreviation ?? state.abbreviation,
            };
        default:
            // Return the same object, not a copy — a fresh identity on every action
            // dispatched anywhere defeats identity-based memoisation downstream.
            return state;
    }
};

export default shopReducer;
